import { BoardsCreateComponent } from '@main-application/boards/boards-create/boards-create.component';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { EIcon } from '@shared/enums/icon.enum';
import { PermissionLevelType } from '@shared/enums/permission-level.enum';
import { MenuSection } from '@shared/interfaces/menu-config.interface';
import { NewTurnoverModalComponent } from '@ui-components/modals/new-turnover-modal/new-turnover-modal.component';

export const MANAGEMENT_EMAIL_DOMAINS = ['gopropup.com', 'onmicrosoft.com'];

/**
 * HOME SECTION
 * */
export const homeSection: MenuSection = {
  label: 'Home',
  urlPath: AppRoutes.HOME,
  icon: EIcon.HOME,
  sectionItem: [],
};

/**
 * ROLES SECTION
 * */
export const rolesSection: MenuSection = {
  label: 'Home',
  urlPath: AppRoutes.ROLES,
  icon: EIcon.HOME,
  sectionItem: [
    {
      label: 'Admin',
      urlPath: AppRoutes.ROLES_ADMIN_HOME,
      icon: EIcon.DASHBOARD,
      permissionLevel: PermissionLevelType.Administrator_Dashboard_Read,
    },
    {
      label: 'Asset',
      urlPath: AppRoutes.ROLES_ASSET_HOME,
      icon: EIcon.DASHBOARD2,
      permissionLevel: PermissionLevelType.AssetManager_PropertyDashboard_Read,
    },
    {
      label: 'Property',
      urlPath: AppRoutes.ROLES_PROPERTY_HOME,
      icon: EIcon.DASHBOARD4,
      permissionLevel: PermissionLevelType.PropertyManager_Dashboard_Read,
    },
    {
      label: 'Vendor',
      urlPath: AppRoutes.ROLES_VENDOR_HOME,
      permissionLevel: PermissionLevelType.Turnovers_Kanban_Read,
      forExternalOnly: true,
      icon: EIcon.TOOLS,
    },
  ],
};

/**
 * TURNOVERS SECTION
 * */
export const turnoversSection: MenuSection = {
  label: 'Turns',
  urlPath: AppRoutes.TURNOVERS,
  icon: EIcon.TIME_SCHEDULE,
  passQueryParams: true,
  permissionLevel: [
    PermissionLevelType.AllPermissions,
    PermissionLevelType.PropertyManager_ActiveTurnovers_Edit,
    PermissionLevelType.PropertyManager_ActiveTurnovers_Read,
    PermissionLevelType.Turnovers_Archived_Read,
  ],
  sectionItem: [
    {
      label: 'Add turn',
      permissionLevelWarning: PermissionLevelType.PropertyManager_ActiveTurnovers_Edit,
      modalDialogComponent: NewTurnoverModalComponent,
    },
  ],
};

export const boardsSection: MenuSection = {
  label: 'Boards',
  urlPath: AppRoutes.BOARDS,
  icon: EIcon.BOARD,
  passQueryParams: true,
  permissionLevel: [
    PermissionLevelType.AllPermissions,
    PermissionLevelType.Board_Use,
    PermissionLevelType.Board_Edit,
    PermissionLevelType.Board_View,
  ],
  sectionItem: [
    {
      label: 'Add board',
      permissionLevelWarning: PermissionLevelType.Board_Edit,
      modalDialogComponent: BoardsCreateComponent,
    },
  ],
};

/**
 * INSPECTIONS SECTION
 * */
export const InspectionsSection: MenuSection = {
  label: 'Inspect',
  urlPath: AppRoutes.INSPECTIONS,
  icon: EIcon.SEARCH,
  passQueryParams: true,
  sectionItem: [
    {
      label: 'Designer',
      urlPath: AppRoutes.SETTINGS_SURVEYS,
      permissionLevel: PermissionLevelType.AllPermissions,
      emailDomains: MANAGEMENT_EMAIL_DOMAINS,
      icon: EIcon.SETTINGS2,
    },
    {
      label: 'Templates',
      urlPath: AppRoutes.SETTINGS_TEMPLATE,
      permissionLevel: PermissionLevelType.InspectionTemplates_List,
      emailDomains: MANAGEMENT_EMAIL_DOMAINS,
      icon: EIcon.SETTINGS2,
    },
    {
      label: 'Spaces',
      urlPath: AppRoutes.SETTINGS_SPACE_TEMPLATE,
      permissionLevel: PermissionLevelType.Inspections_SharedLibrary_List,
      emailDomains: MANAGEMENT_EMAIL_DOMAINS,
      icon: EIcon.SETTINGS2,
    },
  ],
};

export const CalendarSection: MenuSection = {
  label: 'Calendar',
  urlPath: AppRoutes.CALENDAR,
  icon: EIcon.ICON_CALENDAR,
  //permissionLevel: PermissionLevelType.,//ToDo: use correct rights later
  sectionItem: [],
};

export const MaintenanceSection: MenuSection = {
  label: 'Service',
  urlPath: AppRoutes.Maintenance,
  icon: EIcon.Maintenance,
  //permissionLevel: PermissionLevelType.,//ToDo: use correct rights later
  sectionItem: [],
};

/**
 * REPORTS SECTION
 * */
export const reportsSection: MenuSection = {
  label: 'Reports',
  urlPath: AppRoutes.REPORTS,
  icon: EIcon.CHART_LINE,
  passQueryParams: true,
  sectionItem: [
    {
      label: 'Rent Roll',
      urlPath: AppRoutes.REPORTS_RENT_ROLL,
      permissionLevel: [
        PermissionLevelType.PropertyManager_UnitList_Read,
        PermissionLevelType.PropertyManager_Dashboard_Read,
      ],
      icon: EIcon.DASHBOARD,
    },
    {
      label: 'ROC',
      urlPath: AppRoutes.REPORTS_ROC,
      permissionLevel: [
        PermissionLevelType.PropertyManager_UnitList_Read,
        PermissionLevelType.PropertyManager_Dashboard_Read,
      ],
      icon: EIcon.DASHBOARD,
    },
    {
      label: 'Billing',
      urlPath: AppRoutes.REPORTS_BILLING,
      permissionLevel: [PermissionLevelType.AllPermissions],
      emailDomains: MANAGEMENT_EMAIL_DOMAINS,
      icon: EIcon.DASHBOARD,
    },
    // {
    //   label: 'Unit Mix',
    //   urlPath: AppRoutes.REPORTS_UNIT_MIX,
    //   permissionLevel: [
    //     PermissionLevelType.PropertyManager_UnitMix_Read,
    //     PermissionLevelType.PropertyManager_Dashboard_Read,
    //   ],
    //   icon: EIcon.DASHBOARD2,
    // },
    // {
    //   label: 'Delinquencies',
    //   urlPath: AppRoutes.REPORTS_DELINQUENCIES,
    //   permissionLevel: [
    //     PermissionLevelType.PropertyManager_Delinquencies_Read,
    //     PermissionLevelType.PropertyManager_Dashboard_Read,
    //   ],
    //   icon: EIcon.THUNDER_CIRCLE,
    // },
    // {
    //   label: 'Renewals',
    //   urlPath: AppRoutes.REPORTS_RENEWALS,
    //   permissionLevel: [
    //     PermissionLevelType.PropertyManager_Renewals_Read,
    //     PermissionLevelType.PropertyManager_Dashboard_Read,
    //   ],
    //   icon: EIcon.REPEAT,
    // },
  ],
};

/**
 * TICKET SECTION
 * */
export const ticketsSection: MenuSection = {
  label: 'Tickets',
  urlPath: AppRoutes.TICKETS,
  icon: EIcon.TICKET,
  sectionItem: [],
};

/**
 * MANAGEMENT SECTION
 * */
export const managementSection: MenuSection = {
  label: 'Settings',
  urlPath: AppRoutes.SETTINGS,
  icon: EIcon.SETTINGS,
  sectionItem: [
    {
      label: 'Users',
      urlPath: AppRoutes.SETTINGS_USERS,
      permissionLevel: PermissionLevelType.Management_Users,
      icon: EIcon.USER_GROUP,
    },
    {
      label: 'Roles',
      urlPath: AppRoutes.SETTINGS_ROLES,
      permissionLevel: [PermissionLevelType.Management_Roles],
      icon: EIcon.USER,
    },
    // {
    //   label: 'Renewals',
    //   urlPath: AppRoutes.SETTINGS_RENEWAL_STRATEGY,
    //   permissionLevel: PermissionLevelType.Management_UnitTargetRents_Read,
    //   icon: EIcon.DOLLAR,
    // },
    // {
    //   label: 'KPIs',
    //   urlPath: AppRoutes.SETTINGS_KPI,
    //   permissionLevel: PermissionLevelType.Management_KPI_Read,
    //   icon: EIcon.DASHBOARD,
    // },
    {
      label: 'Portfolios',
      urlPath: AppRoutes.SETTINGS_PORTFOLIO,
      permissionLevel: PermissionLevelType.Management_Portfolio_Read,
      icon: EIcon.PORTFOLIOS,
    },
    {
      label: 'Vendors',
      urlPath: AppRoutes.SETTINGS_VENDOR,
      permissionLevel: PermissionLevelType.Companies_Read,
      icon: EIcon.HALF_STAR,
    },
    {
      label: 'Turns',
      urlPath: AppRoutes.SETTINGS_TURNOVER_CONFIGURATION,
      permissionLevel: PermissionLevelType.Management_TurnoverConfiguration_Read,
      icon: EIcon.TIME_SCHEDULE,
    },
    {
      label: 'System',
      urlPath: AppRoutes.SETTINGS_SYSTEM,
      permissionLevel: PermissionLevelType.Chat_Hooks,
      icon: EIcon.SETTINGS2,
    },
  ],
};
